

import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/api';
import Button from '../../components/ui/Button';
import InputWithIcon from '../../components/ui/InputWithIcon';

const AddPurOrderPage = ({ setView, setEditingContext }) => {
  const { user } = useAuth();

  const [suppliers, setsuppliers] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [supplierSearch, setsupplierSearch] = useState('');
  const [filteredsuppliers, setFilteredsuppliers] = useState([]);
  const [selectedsupplier, setSelectedsupplier] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [orderDate, setOrderDate] = useState(new Date().toISOString().split('T')[0]);
  const [editableAddress, setEditableAddress] = useState('');
  const [refNo, setRefNo] = useState('');
  const [amount, setAmount] = useState('');
  const [payMode, setPayMode] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Get GdId from sessionStorage
  const gdId = sessionStorage.getItem("gdid");

  useEffect(() => {
    api.getSuppilerListWithBalance(user.UsrName)
      .then(data => {
        setsuppliers(data.Table || []);
        setPaymentModes(data.Table1 || []);
        if (data.Table1?.length > 0) {
          setPayMode(data.Table1[0].Mode);
        }
      })
      .catch(() => setError('Failed to fetch suppliers.'))
      .finally(() => setLoading(false));
  }, [user.UsrName]);

  useEffect(() => {
  if (supplierSearch) {
    const results = suppliers.filter(c =>
      c.Vname.toLowerCase().includes(supplierSearch.toLowerCase()) ||
      c.Mobile.includes(supplierSearch)
    );

    // If the search matches the selected supplier exactly, hide dropdown
    const exactMatch = selectedsupplier && selectedsupplier.Vname.toLowerCase() === supplierSearch.toLowerCase();
    setFilteredsuppliers(exactMatch ? [] : results);
    setIsDropdownOpen(!exactMatch && results.length > 0);
  } else {
    setFilteredsuppliers([]);
    setIsDropdownOpen(false);
  }
}, [supplierSearch, suppliers, selectedsupplier]);


  const handlesupplierSelect = (supplier) => {
  setSelectedsupplier(supplier);
  setsupplierSearch(supplier.Vname);
  setEditableAddress(`${supplier.Address1}, ${supplier.City}`);
  
  // Close dropdown and clear filtered suppliers
  setIsDropdownOpen(false);
  setFilteredsuppliers([]);
};


  const handlepurCreateOrder = async () => {
    if (!selectedsupplier) {
      setError("Please select a supplier.");
      return;
    }

    const amountAsNumber = parseFloat(amount);
    if (amount && (isNaN(amountAsNumber) || amountAsNumber < 0)) {
      setError('Please enter a valid amount.');
      return;
    }

    if (!gdId) {
      setError('Godown not selected. Please select a godown first.');
      return;
    }


    setError("");
    setLoading(true);

    try {
      const createResult = await api.purcreateOrder({
        User: user.UsrName,
        Vid: selectedsupplier.Vid,
        VName: selectedsupplier.Vname,
        Address: editableAddress,
        Phone: selectedsupplier.Mobile,
        OrderDate: orderDate,
        SessionId: "9944010155",
        amountPaid: amount ? amountAsNumber : 0,
        Paymode: amount ? payMode : '',
        Refno: amount ? refNo : '',
         GdId: Number(gdId) // ✅ include selected godown
      });

      // inside handlepurCreateOrder success case
if (createResult?.Table?.length > 0) {
  const newOrderId = createResult.Table[0].POId;
  const selectedPurOrderData = await api.getpurSelectedOrder(newOrderId);

  setEditingContext({
    id: newOrderId,
    customerId: selectedsupplier.Vid,
    orderDate,
    supplier: selectedsupplier,
    orderDetails: selectedPurOrderData
  });

  // ✅ go to edit page (items step)
  setView('editpur-order');
} else {
  setError("Failed to create order.");
}

    } catch (err) {
      console.error(err);
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top title bar */}
      <div className="p-4 bg-white shadow">
        <h2 className="text-xl font-bold sm:text-2xl text-center">📝Create New Order</h2>
      </div>

      {/* Form container */}
      <div className="flex justify-center mt-6">
        <div className="w-full max-w-lg p-4 bg-white shadow-lg sm:p-6 rounded-xl">

          {/* Search supplier */}
          <div className="relative mb-4">
            <InputWithIcon
              label="Search & Select supplier*"
              value={supplierSearch}
              onChange={(e) => setsupplierSearch(e.target.value)}
              onFocus={() => setIsDropdownOpen(true)}
              icon={
                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              }
            />
            {isDropdownOpen && filteredsuppliers.length > 0 && (
              <ul className="absolute z-10 w-full mt-1 overflow-y-auto text-sm bg-white border rounded-lg shadow-lg max-h-48 sm:max-h-60 sm:text-base">
                {filteredsuppliers.map(c => (
                  <li
                    key={c.Vid}
                    onMouseDown={() => handlesupplierSelect(c)}  // <-- use onMouseDown
                    className="px-3 py-3 border-b cursor-pointer hover:bg-gray-100 last:border-none"
                  >
                    <p className="font-semibold">{c.Vname}</p>
                    <p className="text-gray-500">{c.Mobile}</p>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Order Date */}
          <div className="mb-4">
            <InputWithIcon
              label="Order Date*"
              type="date"
              value={orderDate}
              onChange={e => setOrderDate(e.target.value)}
            />
          </div>

          {/* Selected supplier Details */}
          {selectedsupplier && (
            <div className="p-4 mb-4 bg-white border rounded-lg shadow-sm">
              <h3 className="pb-2 mb-3 text-base font-semibold border-b">supplier Details</h3>

              <label className="block mb-2 text-sm font-bold">Delivery Address*</label>
              <textarea
                value={editableAddress}
                onChange={(e) => setEditableAddress(e.target.value)}
                className="w-full p-2 mb-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="3"
              />

              <div className="space-y-1 text-sm">
                <p><span className="font-semibold">📞 Mobile:</span> {selectedsupplier.Mobile}</p>
                <p>
                  <span className="font-semibold">💰 Current Balance:</span>
                  <span className={`ml-1 font-bold ${selectedsupplier.Balance <= 0 ? 'text-green-600' : 'text-red-600'}`}>
                    {selectedsupplier.Balance.toLocaleString('en-IN', { style: 'currency', currency: 'INR' })}
                  </span>
                </p>
              </div>

              {/* Payment Section */}
              {/* <div className="mt-4"> */}
                {/* <h4 className="pb-1 mb-3 font-semibold border-b">Payment (Optional)</h4> */}
                {/* <div className="grid grid-cols-1 gap-3 sm:grid-cols-3"> */}
                  {/* <InputWithIcon label="Ref No" value={refNo} onChange={(e) => setRefNo(e.target.value)} /> */}
                  {/* <InputWithIcon label="Amount" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} /> */}
                  {/* <div> */}
                    {/* <label className="block mb-2 text-sm font-bold">Pay Mode</label> */}
                    {/* <select
                      value={payMode}
                      onChange={(e) => setPayMode(e.target.value)}
                      className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      {paymentModes.map((mode, idx) => (
                        <option key={idx} value={mode.Mode}>{mode.Mode}</option>
                      ))}
                    </select> */}
                  {/* </div> */}
                {/* </div> */}
              {/* </div> */}
            </div>
          )}

          {/* Buttons */}
          <div className="flex gap-2 pt-2 justify-start">
            <Button
              onClick={handlepurCreateOrder}
              disabled={!selectedsupplier || loading}
              className="px-3 py-1 text-sm"
            >
              {loading ? 'Creating...' : '✅ Create Order'}
            </Button>
            <Button
              onClick={() => setView('list')}
              className="px-3 py-1 text-sm bg-gray-500 hover:bg-gray-600"
            >
             ❌ Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPurOrderPage;
